<template>
  <div class="team-list-transfer" v-loading="loading">
    <div class="team-list-transfer__teams">
      <el-row :gutter="10" type="flex" justify="center">

        <!-- Program -->
        <el-col :lg="6" :md="6" :sm="6">
          <span class="team-list-transfer--text-left">
            <app-i18n code="entities.program.label.one" />
          </span>

          <app-autocomplete-one-input
            :fetchFn="fields.program.fetchFn"
            :manage="{ subpropertyId, type: 'program' }"
            v-model="program"
            prefix-icon="icon-cup"
          ></app-autocomplete-one-input>
        </el-col>

        <!-- Subprogram -->
        <el-col :lg="6" :md="6" :sm="6">
          <span v-if="programId" class="team-list-transfer--text-left">
            <app-i18n code="entities.category.label.one" />
          </span>
          <app-autocomplete-one-input
            v-if="programId"
            :fetchFn="fields.subprogram.fetchFn"
            :key="programId"
            :manage="{ subpropertyId, programId: program.id, type: 'subprogram'}"
            v-model="subprogram"
            prefix-icon="icon-cup"
          ></app-autocomplete-one-input>
        </el-col>
      </el-row>

      <el-row :gutter="10" type="flex" justify="center">

        <!-- Team list transfer -->
        <el-col :lg="24" :md="24" :sm="24">
          <el-transfer
            :data="listTeamFull"
            :titles="transferTitles"
            filter-placeholder="Search team..."
            filterable
            style="text-align: left; display: inline-block"
            v-model="listTeamPlayer"
          >
            <span slot-scope="{ option: team }">
              <div class="option">
                <div v-if="listTeamPlayer.some((i) => i === getKey(team))">
                  <span>{{ team.program.name}}</span>
                  <span>{{ ' - '}}</span>
                  <span>{{ team.subprogram.name}}</span>
                </div>
                <div>
                  <strong>{{ team.name }}</strong>
                </div>
              </div>
            </span>
          </el-transfer>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { TeamModel } from '@modules/team/team-model';
import { ProgramModel } from '@modules/program/program-model';

import { i18n } from '@shared/i18n';
import _ from 'underscore';

const { fields } = TeamModel;

export default {
  name: 'app-team-list-transfer',
  props: {
    listTeamPlayerInitial: {
      type: Array,
      required: true,
    },

    listTeamPlayerResult: {
      type: Array,
      required: true,
    },

    playerFullname: {
      type: String,
    },

    subpropertyId: {
      type: String,
      required: true,
    },

    programInitial: {
      type: Object,
      default: null,
    },

    subprogramInitial: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      listTeamFull: [],
      listTeamPlayer: [],
      transferTitles: [ i18n('entities.team.label.many'), this.playerFullname ],
      program: { id: null },
      subprogram: { id: null },
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      rows: 'team/listTransfer/rows',
      loading: 'team/listTransfer/loading',
    }),

    fields() {
      return fields;
    },

    programId({ program }) {
      return program ? program.id : null
    },

    subprogramId({ subprogram }) {
      return subprogram ? subprogram.id : null
    }
  },

  mounted() {
    this.initSelect();
    this.initListTeamPlayer();
  },

  methods: {
    ...mapActions({
      doFetch: 'team/listTransfer/doFetch',
    }),

    i18n(code) {
      return i18n(code);
    },

    presenterProgram(record, fieldName) {
      return ProgramModel.presenter(record, fieldName);
    },

    initSelect() {
      this.program = this.programInitial;
      this.subprogram = this.subprogramInitial;
    },

    initListTeamPlayer() {
      this.listTeamFull = this.listTeamPlayerInitial.map((e) => ({...e, key: this.getKey(e), label: this.getTeamFullLabel(e)}));
      this.listTeamPlayer = this.listTeamPlayerInitial.map(
        (e) => {
          return this.getKey(e);
        },
      );
    },
    
    getTeamFullLabel({
      program,
      subprogram,
      name,
    }) {
      return `${program.name} ${subprogram.name} <strong>${name}</strong>`;
    },

    getKey(team) {
      return `${team.id}-${team.subprogram.id}`
    },

    async loadListTeams({ subpropertyId, programId, subprogramId }) {
      await this.doFetch({ 
        filter: {
          program: programId,
          subprogram: subprogramId,
        },
        manage: { 
          subpropertyId,
          program: programId,
          subprogram: subprogramId,
          type: 'subprogram' 
        } 
      });
      
      const teamListTeams = this.rows.map((e) => ({...e, key: this.getKey(e),  label: this.getTeamFullLabel(e)}));
      
      this.listTeamFull = _.uniq(
        _.union(this.listTeamFull.filter((e) => this.listTeamPlayer.some((i) => i === this.getKey(e))), teamListTeams),
        (e) => {
          return this.getKey(e);
        },
      );
    },
  },

  watch: {
    listTeamPlayer(newListTeam) {
      // Filtrar
      const listTeamToSend = this.listTeamFull
        .filter((e) => {
          return newListTeam.some((key) => {
            return key == this.getKey(e);
          });
        })
      this.$emit(
        'update:listTeamPlayerResult',
        listTeamToSend,
      );
    },

    async 'subprogram.id'(subprogramId) {
      const {
        subpropertyId,
        programId,
      } = this;

      if (programId && subprogramId) {
        await this.loadListTeams(
          { subpropertyId, programId, subprogramId },
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.team-list-transfer {
  &--text-left {
    float: left;
  }
  &__teams {
    .el-row {
      padding: 2em 0;
    }
    .el-transfer {
      .el-transfer-panel {
        widows: 800px;
        // TODO: corregir with
      }
    }
  }
}
</style>
